import { render } from "./CheckoutPage.vue?vue&type=template&id=20dc3153&scoped=true&ts=true"
import script from "./CheckoutPage.vue?vue&type=script&lang=ts"
export * from "./CheckoutPage.vue?vue&type=script&lang=ts"

import "./CheckoutPage.vue?vue&type=style&index=0&id=20dc3153&scoped=true&lang=css"

import exportComponent from "/home/runner/work/a-gallery-tvp/a-gallery-tvp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20dc3153"]])

export default __exports__